import Utility from "../../../model/utility/Utility";

export const UTILITIES_FETCHED = "UTILITIES_FETCHED";
export type UTILITIES_FETCHED = { utilities: Array<Utility> }

export const UTILITY_CREATED = "UTILITY_CREATED";
export type UTILITY_CREATED = { utility: Utility }

export const UTILITY_UPDATED = "UTILITY_UPDATED";
export type UTILITY_UPDATED = { utility: Utility }

export const UTILITY_DELETED = "UTILITY_DELETED";
export type UTILITY_DELETED = { utilityId: string }